var _toConsumableArray = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _slicedToArray = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/objectWithoutProperties", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/defineProperty", "@babel/runtime/helpers/slicedToArray", "elasticsearch", "bodybuilder", "lodash.debounce"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/objectWithoutProperties"), require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/defineProperty"), require("@babel/runtime/helpers/slicedToArray"), require("elasticsearch"), require("bodybuilder"), require("lodash.debounce"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.objectWithoutProperties, a.regenerator, a.asyncToGenerator, a.defineProperty, a.slicedToArray, a.elasticsearch, a.bodybuilder, a.lodash), a.search = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f, g, h, i) {
  "use strict";

  var l = require("@babel/runtime/helpers/interopRequireDefault");

  function j(a, b) {
    var c = Object.keys(a);

    if (Object.getOwnPropertySymbols) {
      var d = Object.getOwnPropertySymbols(a);
      b && (d = d.filter(function (b) {
        return Object.getOwnPropertyDescriptor(a, b).enumerable;
      })), c.push.apply(c, d);
    }

    return c;
  }

  function k(a) {
    for (var b, c = 1; c < arguments.length; c++) {
      b = null == arguments[c] ? {} : arguments[c], c % 2 ? j(b, !0).forEach(function (c) {
        (0, e.default)(a, c, b[c]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : j(b).forEach(function (c) {
        Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
      });
    }

    return a;
  }

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.Search = a.buildQuery = a.getSearchParamFromProperty = a.getExtent = a.getExtentWithPadding = a.SEARCHES_QUEUE = a.MAX_SIZE = void 0, b = l(b), c = l(c), d = l(d), e = l(e), f = l(f), g = l(g), h = l(h), i = l(i);
  var m = 1e4;
  a.MAX_SIZE = m;
  var n = new Set();
  a.SEARCHES_QUEUE = n;

  var o = function o(a, _ref) {
    var b = _ref.top,
        c = _ref.left,
        d = _ref.width,
        e = _ref.height;
    var f = a.unproject([c, b]).toArray(),
        g = a.unproject([d + c, e + b]).toArray();
    return [f, g];
  };

  a.getExtentWithPadding = o;

  var p = function p(a, b) {
    if (b) return o(a, b);
    var c = a.getBounds().toArray(),
        d = (0, f.default)(c, 2),
        e = (0, f.default)(d[0], 2),
        g = e[0],
        h = e[1],
        i = (0, f.default)(d[1], 2),
        j = i[0],
        k = i[1];
    return [[g, k], [j, h]];
  };
  /**
  * Construct an object representing the current properties to search on.
  *
  * @param properties {{}} Filter properties
  * @param form {{}} Schema form containing filters
  * @param key {string} Property key
  * @return {{}} An object usable by searchService (Search.search() or Search.msearch())
  */


  a.getExtent = p;

  a.getSearchParamFromProperty = function (a, b, c) {
    var d = b.find(function (_ref2) {
      var a = _ref2.property;
      return a === c;
    }) || {},
        e = d.type,
        f = d.values;
    return a[c] ? "range" === e ? _defineProperty({}, c, {
      type: "range",
      value: {
        min: a[c][0],
        max: a[c][1]
      }
    }) : f ? _defineProperty({}, "".concat(c, ".keyword"), {
      type: "term",
      value: a[c]
    }) : _defineProperty({}, c, a[c]) : {};
  };
  /**
  * Build an Elastic Search query
  * @param {String} [query] A literal query
  * @param {Array} [boundingBox] Boundingbox to restrict results
  * @param {Number} [size=MAX_SIZE] Max number of results to fetch
  * @param {{}} [properties] Object representing properties.
  *   Each property should be a key/value association. Value may be a single
  *   value or an object describing the value and type
  * @param {String[]} [include] List of fields to include in results hits
  * @param {String[]} [exclude] List of fields to exclude in results hits.
  * @param {Object[]} [aggregations] Array of aggregations definition.
  *   Each aggregation will take a type, a field, a name and options.
  *    See https://bodybuilder.js.org/docs/#aggregation
  * @param {{}} [baseQuery] base query to start over.
  * @param {{}} [hookQuery] Allow to access bodybuild before the end.
  */


  var q = function q(_ref6) {
    var _ref6$query = _ref6.query,
        f = _ref6$query === void 0 ? "" : _ref6$query,
        a = _ref6.boundingBox,
        _ref6$size = _ref6.size,
        g = _ref6$size === void 0 ? m : _ref6$size,
        b = _ref6.properties,
        c = _ref6.include,
        d = _ref6.exclude,
        e = _ref6.aggregations,
        _ref6$baseQuery = _ref6.baseQuery,
        i = _ref6$baseQuery === void 0 ? {} : _ref6$baseQuery,
        _ref6$hookQuery = _ref6.hookQuery,
        j = _ref6$hookQuery === void 0 ? function () {} : _ref6$hookQuery;
    var k, l;
    var n = (0, h.default)();
    (null === i || void 0 === i || null === (k = i.query) || null == k || null === (l = k.bool) || null == l ? void 0 : l.filter) && Object.entries(i.query.bool.filter).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          a = _ref8[0],
          b = _ref8[1];

      n.filter(a, b);
    }), n.size(g), n.rawOption("track_total_hits", !0), f && n.query("query_string", "query", f.split(/\s+/).map(function (a) {
      return "*".concat(a, "*");
    }).join(" AND ")), b && Object.keys(b).forEach(function (a) {
      var c = b[a],
          d = "object" != typeof c || Array.isArray(c) ? {
        value: c
      } : c,
          e = d.value,
          f = d.type,
          g = void 0 === f ? "match" : f;
      if (e) if ("number" == typeof e.min && "number" == typeof e.max) {
        var _b = e.min,
            _c = e.max;
        n.filter("range", a, {
          gte: +_b,
          lte: +_c
        });
      } else if (Array.isArray(e)) n.filter("bool", function (b) {
        return b.orFilter("terms", a, e);
      });else {
        [e].forEach(function (b) {
          "match" === g && "string" == typeof b ? n.filter("bool", function (c) {
            return c.orFilter(g, a, b).orFilter("wildcard", a, "*".concat(b, "*"));
          }) : n.filter(g, a, b);
        });
      }
    }), a && n.filter("geo_shape", "geom", {
      shape: {
        type: "envelope",
        coordinates: a
      }
    }), e && e.forEach(function (_ref9) {
      var _ref9$type = _ref9.type,
          d = _ref9$type === void 0 ? "terms" : _ref9$type,
          a = _ref9.field,
          b = _ref9.options,
          c = _ref9.name;
      return n.aggregation(d, a, b, c);
    }), j(n);
    var o = n.build();

    if (c || d) {
      o._source = {}, c && !c.length ? o._source = !1 : (c && (o._source.includes = c), d && (o._source.excludes = d));
    }

    return o;
  };

  a.buildQuery = q;

  var r =
  /*#__PURE__*/
  function () {
    function r(a) {
      _classCallCheck(this, r);

      var b = this;
      (0, e.default)(this, "batchSearch", (0, i.default)(
      /*#__PURE__*/
      (0, d.default)(
      /*#__PURE__*/
      c.default.mark(function a() {
        var d, e, g, h, i, j, k, l;
        return c.default.wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                return d = Array.from(n.values()).reduce(function (_ref10, _ref11) {
                  var _ref12 = _slicedToArray(_ref10, 3),
                      a = _ref12[0],
                      b = _ref12[1],
                      c = _ref12[2];

                  var _ref11$header = _ref11.header,
                      f = _ref11$header === void 0 ? {} : _ref11$header,
                      d = _ref11.body,
                      e = _ref11.resolve;
                  return [[].concat(_toConsumableArray(a), [f]), [].concat(_toConsumableArray(b), [d]), [].concat(_toConsumableArray(c), [e])];
                }, [[], [], []]), e = (0, f.default)(d, 3), g = e[0], h = e[1], i = e[2], j = h.map(function (a, b) {
                  return [g[b], a];
                }).reduce(function (a, _ref13) {
                  var _ref14 = _slicedToArray(_ref13, 2),
                      b = _ref14[0],
                      c = _ref14[1];

                  return [].concat(_toConsumableArray(a), [b, c]);
                }, []), n.clear(), a.next = 5, b.client.msearch({
                  body: j
                });

              case 5:
                k = a.sent, l = k.responses, i.forEach(function (a, b) {
                  return a(l[b]);
                });

              case 8:
              case "end":
                return a.stop();
            }
          }
        }, a);
      })), 500)), this.host = a;
    }

    _createClass(r, [{
      key: "search",

      /**
      * Perform a single search
      *
      * For performance purposes, this search is added to a queue, which is sent
      * as multi-search (msearch).
      *
      * @param {String} query
      * @see buildQuery()
      * @param {String} [query.index] The ES index to search on
      * @return {Promise<unknown>}
      */
      value: function search() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          /*
          query = '',
          boundingBox,
          properties,
          include,
          size = MAX_SIZE,
          index = DEFAULT_INDEX,
          */
        };
        var b = this;
        return (0, d.default)(
        /*#__PURE__*/
        c.default.mark(function d() {
          var e, f, g, h;
          return c.default.wrap(function (c) {
            for (;;) {
              switch (c.prev = c.next) {
                case 0:
                  return e = q(a), f = a.index, g = {
                    body: e
                  }, f && (g.header = {
                    index: f
                  }), h = new Promise(function (a) {
                    g.resolve = a;
                  }), n.add(g), b.batchSearch(), c.abrupt("return", h);

                case 8:
                case "end":
                  return c.stop();
              }
            }
          }, d);
        }))();
      }
      /**
      * Perform a multi-search
      *
      * @see search()
      *
      * @param queries
      */

    }, {
      key: "msearch",
      value: function msearch() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
          /* {
          query: String,q
          include: String,
          properties: {
          property: String,
          //…
          }
          } */
        ];
        var e = this;
        return (0, d.default)(
        /*#__PURE__*/
        c.default.mark(function d() {
          var f, g;
          return c.default.wrap(function (c) {
            for (;;) {
              switch (c.prev = c.next) {
                case 0:
                  if (a.length) {
                    c.next = 2;
                    break;
                  }

                  throw new Error("`queries` must not be empty");

                case 2:
                  return f = m / a.length, g = a.map(function (a) {
                    var c = a.size,
                        d = void 0 === c ? f : c,
                        e = a.index,
                        g = (0, b.default)(a, ["size", "index"]);
                    return [{
                      index: e
                    }, q(k({
                      size: d
                    }, g))];
                  }).reduce(function (a, _ref15) {
                    var _ref16 = _slicedToArray(_ref15, 2),
                        b = _ref16[0],
                        c = _ref16[1];

                    return [].concat(_toConsumableArray(a), [b, c]);
                  }, []), c.abrupt("return", e.client.msearch({
                    body: g
                  }));

                case 5:
                case "end":
                  return c.stop();
              }
            }
          }, d);
        }))();
      }
      /**
      * Consume SEARCHES_QUEUE as a batch of queries and send them as msearch.
      */

    }, {
      key: "host",
      set: function set(a) {
        this.client = new g.default.Client({
          host: a
        });
      }
    }]);

    return r;
  }();

  a.Search = r;
  var s = new r();
  a.default = s;
});